import { ListToolbar } from "./ListToolbar";

const ListHeader = () => {
  return (
    <div className="card-header border-0 pt-5">
      <div className="d-flex align-items-center items-center gap-5">
        <div className="symbol symbol-35px me-3">
          <div className="symbol-label bg-primary">
            <i className="fas fa-users text-white"></i>
          </div>
        </div>
        <h3 className="card-title align-items-start flex-column">
        <span className="card-label fw-bold fs-3 mb-1">User List</span>
        </h3>
      </div>
      
      <div className="card-toolbar">
        <ListToolbar />
      </div>
    </div>
  );
};

export { ListHeader };
